import "../i18n";
import { Loading } from "../shared/components/common/Loading";
import { useAuthInit } from "../store";
import { AppRouter } from "./router";

function App() {
  const { isInitializing } = useAuthInit();

  if (isInitializing) {
    return <Loading fullScreen />;
  }

  return <AppRouter />;
}

export default App;
